<template>
     <nav class='navbar navbar-expand-lg fixed-top d-none d-lg-block'>
        <div class='container'>
            <DropDownMenu
                :menus='menus'
                :class='"me-auto"' />
            <!-- Languages -->
            <LanguageSwitcher></LanguageSwitcher>
            <div>
              <label>
                  <input @input="handleSearch($event)" class='form-control search-input' id='search' type='search' :placeholder="$t('default.header.search')" aria-label='Search'>
              </label>
              <drop-down-search :is-open="isSearchOpen" :results="searchResult" />
            </div>
        </div>
    </nav>
</template>
<script>
import DropDownMenu from '@/components/core/Navigation/DropDown/DropDownMenu.vue'
import LanguageSwitcher from '@/components/core/LanguageSwitcher'
import DropDownSearch from '../DropDown/DropDownSearch'

export default {
  name: 'TheHeaderLg',

  props: ['menus', 'searchResult', 'isSearchOpen'],

  components: {
    DropDownSearch,
    DropDownMenu,
    LanguageSwitcher
  },

  methods: {
    handleSearch (event) {
      this.$emit('search', event.target.value)
    }
  }
}
</script>
<style scoped>
  .search-input {
    width: 300px
  }
</style>
